export const ru = {
    action_submit: 'Выбрать',
    approver_required: 'Необходимо выбрать согласующего',
    access_for: 'Доступ для',
    approver: 'Согласующий',
    company: 'Компания',
};
